export const AccountStatus = Object.freeze({
  CONTACT_COMPLETE: "CONTACT_COMPLETE",
  INVITATION_PENDING: "INVITATION_PENDING",
  PARTICULIER_BLOQUE: "PARTICULIER_BLOQUE",
  APPAREILLAGE_EC: "APPAREILLAGE_EC",
  APPAREILLAGE_NF: "APPAREILLAGE_NF",
  APPAREILLAGE_VALIDE: "APPAREILLAGE_VALIDE",
  ERROR: "ERROR",
  MANDAT_ECHU: "MANDAT_ECHU",
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
} as const);

export type AccountStatusType =
  (typeof AccountStatus)[keyof typeof AccountStatus];

export const AccountStatusLabel: Record<AccountStatusType, string> = {
  [AccountStatus.CONTACT_COMPLETE]: "Complété",
  [AccountStatus.INVITATION_PENDING]: "Envoyé",
  [AccountStatus.PARTICULIER_BLOQUE]: "Bloqué",
  [AccountStatus.APPAREILLAGE_EC]: "En cours",
  [AccountStatus.APPAREILLAGE_NF]: "Non finalisé",
  [AccountStatus.APPAREILLAGE_VALIDE]: "Validé",
  [AccountStatus.ERROR]: "Erreur",
  [AccountStatus.MANDAT_ECHU]: "Mandat expire",
  [AccountStatus.ACTIVE]: "Actif",
  [AccountStatus.PENDING]: "En attente",
};
